import { useReadMovieTrailerPlayerBaseInfo } from '../../movie-trailer-player/hooks/use-read-movie-trailer-player-base-info';
import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

export const useCurrentTrailerStream = (contentId: string) => {
    const trailer = useReadMovieTrailerPlayerBaseInfo(contentId);

    return useCurrentStream(contentId ? trailer?.streams ?? null : null);
};
